import { useEffect, useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TextField, Tooltip, Typography, InputAdornment } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";

const date = (value) => value != null && !Number.isNaN(new Date(value).getTime())
    ? new Date(value).toLocaleDateString("el-GR", { timeZone: "Europe/Athens" }) : "—";

export default function ExcludedEwes({ results }) {
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState("");
    useEffect(() => { setOpen(false); setQuery(""); }, [results]);
    const animals = results?.animals || [];
    const filtered = animals.filter((animal) => String(animal.registrationCode).includes(query.trim()));
    return <Box sx={{ flex: "1 1 240px" }}>
        <TextField id="excluded-ewes-count" label="Εξαιρέθηκαν προβατίνες" value={results ? animals.length : "—"} variant="standard" fullWidth
            helperText={!results ? "Πατήστε «Επιλογή επιλέξιμων» για έλεγχο." : undefined}
            InputProps={{ readOnly: true, endAdornment: <InputAdornment position="end">
                <Tooltip title="Δείτε τις προβατίνες και τους λόγους εξαίρεσης">
                    <span><IconButton aria-label="Προβολή εξαιρεμένων προβατίνων" disabled={animals.length === 0}
                        onClick={() => { setQuery(""); setOpen(true); }} sx={{ width: 44, height: 44 }}><VisibilityIcon /></IconButton></span>
                </Tooltip>
            </InputAdornment> }} />
        <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="lg" aria-labelledby="excluded-ewes-title">
            <DialogTitle id="excluded-ewes-title">Εξαιρεμένες προβατίνες ({animals.length})</DialogTitle>
            <DialogContent>
                <Typography sx={{ mb: 1 }}>Επιλεγμένη σύζευξη: {date(results?.start)}–{date(results?.end)}</Typography>
                <Typography sx={{ mb: 2 }}>
                    Οι παρακάτω προβατίνες δεν επιλέχθηκαν αυτόματα για αυτές τις ημερομηνίες.
                    Για κάθε ζώο εμφανίζονται όλοι οι λόγοι εξαίρεσης που βρέθηκαν στα καταχωρημένα στοιχεία.
                    Οι προβατίνες που επιτρέπονται με προειδοποίηση δεν περιλαμβάνονται εδώ.
                </Typography>
                <TextField label="Αναζήτηση κωδικού γενεαλογικού βιβλίου" type="search" fullWidth size="small"
                    value={query} onChange={(event) => setQuery(event.target.value)} sx={{ mb: 1 }} />
                <Typography variant="body2" sx={{ mb: 1 }}>Εμφανίζονται {filtered.length} από {animals.length} προβατίνες.</Typography>
                <TableContainer sx={{ maxHeight: "50vh" }}>
                    <Table stickyHeader size="small" aria-label="Λόγοι εξαίρεσης προβατίνων">
                        <TableHead><TableRow>
                            <TableCell>Κωδικός Γενεαλογικού Βιβλίου</TableCell>
                            <TableCell>Αιτίες και σχετικά στοιχεία</TableCell>
                        </TableRow></TableHead>
                        <TableBody>{filtered.map((animal) => <TableRow key={animal.registrationCode}>
                            <TableCell sx={{ verticalAlign: "top", whiteSpace: "nowrap" }}>{animal.registrationCode}</TableCell>
                            <TableCell>{animal.reasons?.length ? animal.reasons.map((reason, index) => <Box key={`${reason.code}-${index}`}
                                sx={{ mb: 1.5, pb: 1, borderBottom: "1px solid", borderColor: "divider" }}>
                                <Typography sx={{ fontWeight: 700 }}>{reason.title || reason.message}</Typography>
                                {(reason.dates || []).map((entry, dateIndex) => <Typography variant="body2" key={dateIndex}>
                                    {entry.label}: {date(entry.value)}
                                </Typography>)}
                                {reason.actualDays != null && <Typography variant="body2">
                                    Διάστημα: {reason.actualDays} ημέρες. Χρειάζονται τουλάχιστον {reason.minimumDays} ημέρες.
                                </Typography>}
                            </Box>) : <Typography>Δεν πληροί τους ελέγχους για τις επιλεγμένες ημερομηνίες.</Typography>}</TableCell>
                        </TableRow>)}
                            {!filtered.length && <TableRow><TableCell colSpan={2}>Δεν βρέθηκαν προβατίνες με αυτόν τον κωδικό.</TableCell></TableRow>}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions><Button onClick={() => setOpen(false)}>Κλείσιμο</Button></DialogActions>
        </Dialog>
    </Box>;
}
